import { ModuleWithProviders, NgModule } from '@angular/core';
import { provideFeatureFlag } from '@y42/feature-flag';
import { Y42_FEATURE_FLAGS } from './y42-feature-flag.model';

@NgModule()
export class Y42FeatureFlagModule {
  static forRoot(): ModuleWithProviders<Y42FeatureFlagModule> {
    return {
      ngModule: Y42FeatureFlagModule,
      providers: [provideFeatureFlag(Y42_FEATURE_FLAGS)],
    };
  }
}
